import { Badge, Button, Flex, Icon, IconButton, IconName, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

export interface PaymentMethodsAccordionProps {
  badgeLabel?: string
  children: ReactElement
  icon: IconName
  initialIsOpen: boolean
  onDelete?: () => void
  title: string
}

export const PaymentMethodsAccordion = ({
  badgeLabel,
  children,
  icon,
  initialIsOpen,
  onDelete,
  title,
}: PaymentMethodsAccordionProps): ReactElement => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(initialIsOpen)

  const handleAddButtonClick = () => {
    setIsOpen(true)
  }

  const handleDeleteButtonClick = useCallback(() => {
    setIsOpen(false)
    onDelete?.()
  }, [onDelete])

  return (
    <Styled.AccordionWrapper>
      <Styled.AccordionHeaderWrapper>
        <Flex alignItems="center" justifyContent="space-between">
          <Flex alignItems="center" gap={Spacing.S8}>
            <Icon icon={icon} color="currentColor" />
            <Text weight="bold">{title}</Text>
            {badgeLabel && (
              <Badge color="success" mode="subtle">
                {badgeLabel}
              </Badge>
            )}
          </Flex>
          {!isOpen && (
            <Button variant="outlined" size="sm" onClick={handleAddButtonClick}>
              {t('external_invoices.payment_methods_modal.add')}
            </Button>
          )}
          {isOpen && onDelete && <IconButton onClick={handleDeleteButtonClick} icon="trash" />}
        </Flex>
      </Styled.AccordionHeaderWrapper>
      <Styled.ContentWrapper isOpen={isOpen}>
        <Styled.ContentInner>
          <Flex flexDirection="column" gap={Spacing.S16}>
            {children}
          </Flex>
        </Styled.ContentInner>
      </Styled.ContentWrapper>
    </Styled.AccordionWrapper>
  )
}
